<app-services-table [data]="addedServices" (addService)="addService()" (deleteService)="deleteService($event)"></app-services-table>
